import PageWrapper from 'components/utils/PageWrapper';
import PriceFormula from 'pages/PriceFormula';

export const priceFormulaRoutes = {
    path: '/price-formula/:priceFormulaId',
    element: (
        <PageWrapper titleId="price_formula_page_title">
            <PriceFormula />
        </PageWrapper>
    ),
};
